export default () => (
    {
        imageUrl: '',
        loaded: false,
        shown: false,
        shownTransitionEnd: false,
        opacity: 0,
        opacityInterval: null,
        opacityDuration: 150,
        opacitySteps: 15,
        sliderElAncestor: null,
        useOpacity: false,

        init() {
            this.imageUrl   = this.$el.dataset.imageUrl;
            this.useOpacity = !!parseInt(this.$el.dataset.useOpacity);

            this.$watch('shown', () => {
                if (!this.shown) return;
                setTimeout(() => {
                    this.shownTransitionEnd = true;
                }, this.opacityDuration);
            });
        },

        loadImage() {
            if (this.loaded) return;

            this.sliderElAncestor = this.$root.closest('.swiper');

            let img = new Image();
            img.src = this.imageUrl;

            if (img.complete) {
                this.onImageLoaded();
                return;
            }

            img.onload = () => {
                this.onImageLoaded();
            };

            img.onerror = () => {
                console.log('error on loading image', this.imageUrl);
            };
        },

        onImageLoaded() {

            this.loaded = true;

            if (!this.useOpacity) {
                this.shown = true;
                return;
            }

            let opacityIntervalTimeout = 100;

            this.opacityInterval = setInterval(() => {
                if (this.sliderElAncestor !== null) {
                    if (this.sliderElAncestor.classList.contains('swiper-touching')) return;
                    if (this.sliderElAncestor.classList.contains('swiper-transition')) return;
                }

                if (this.opacity >= 1) {
                    clearInterval(this.opacityInterval);
                    this.shown = true;
                    return;
                }

                setTimeout(() => {
                    this.opacity = 1;
                }, 150);

            }, opacityIntervalTimeout);
        },

        isImageCached(src) {
            const img = new Image();
            img.src   = src;
            return img.complete;
        },

        onImageLoad() {
            this.onImageLoaded();
        }

    });